__turbopack_context__.v({
  "button": "SelectTextField-module-scss-module__Q0NBAa__button",
  "disabled": "SelectTextField-module-scss-module__Q0NBAa__disabled",
  "error": "SelectTextField-module-scss-module__Q0NBAa__error",
  "icon": "SelectTextField-module-scss-module__Q0NBAa__icon",
  "placeholder": "SelectTextField-module-scss-module__Q0NBAa__placeholder",
  "text": "SelectTextField-module-scss-module__Q0NBAa__text",
  "value": "SelectTextField-module-scss-module__Q0NBAa__value",
});
